import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const BWStatusBadge = ({ tone = 'neutral', children, className = '', title }) => (
  <span
    className={`bw_status_badge bw_status_badge_${tone}${className ? ` ${className}` : ''}`}
    title={title}>
    {children}
  </span>
);

BWStatusBadge.propTypes = {
  tone: PropTypes.oneOf(['neutral', 'info', 'success', 'warning', 'danger']),
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string,
};

export default BWStatusBadge;
